import { render } from "./UiPropTreeStorageSelector.vue?vue&type=template&id=20c49c66"
import script from "./UiPropTreeStorageSelector.vue?vue&type=script&lang=js"
export * from "./UiPropTreeStorageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__